/**
 * Portal Manta · PassCross
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { M } from '../../tokens/colors.js';

function PassCross({label, estrutura, cobertura, w=320}){
  return (<div style={{textAlign:'center'}}>
    <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>{label}</div>
    <svg width={w} height={200} viewBox={`0 0 ${w} 200`}>
      {/* Cobertura policarbonato (se houver) */}
      {cobertura && (<g>
        <path d={`M ${w/2-90} 35 L ${w/2} 25 L ${w/2+90} 35 L ${w/2+85} 40 L ${w/2-85} 40 Z`} fill="#B8E0F5" stroke={V.bl} strokeWidth="0.8" opacity="0.7"/>
        <text x={w/2} y={32} textAnchor="middle" fontSize="8" fill={V.bl} fontWeight="600">Cobertura policarbonato</text>
      </g>)}
      {/* Treliça metálica laterais */}
      <g stroke={V.br} strokeWidth="1.5" fill="none">
        <line x1={w/2-90} y1={50} x2={w/2-90} y2={90}/>
        <line x1={w/2+90} y1={50} x2={w/2+90} y2={90}/>
        {[0,1,2,3,4].map(i=>{
          const xa = w/2-90+i*45, xb = w/2-90+(i+1)*45;
          return (<g key={i}>
            <line x1={xa} y1={50} x2={xb} y2={50}/>
            <line x1={xa} y1={50} x2={xb} y2={80}/>
            <line x1={xb} y1={50} x2={xa} y2={80}/>
          </g>);
        })}
      </g>
      {/* Tabuleiro */}
      <rect x={w/2-90} y={80} width={180} height={10} fill="#666"/>
      <text x={w/2} y={87} textAnchor="middle" fontSize="8" fill="#fff">Tabuleiro 3,0 m</text>
      {/* Pista por baixo */}
      <rect x={20} y={100} width={w-40} height={20} fill="#444" opacity="0.4"/>
      <text x={w/2} y={113} textAnchor="middle" fontSize="9" fill="#fff">pista da rodovia</text>
      {/* Pilares */}
      <rect x={w/2-92} y={120} width={6} height={60} fill={V.g7}/>
      <rect x={w/2+86} y={120} width={6} height={60} fill={V.g7}/>
      <text x={w/2} y={155} textAnchor="middle" fontSize="9" fill={V.g5}>2× Pilares concreto</text>
      {/* Indicador vão */}
      <line x1={w/2-90} y1={45} x2={w/2+90} y2={45} stroke={V.g4} strokeWidth="0.6" markerStart="url(#arr)" markerEnd="url(#arr)"/>
      <text x={w/2} y={42} textAnchor="middle" fontSize="9" fill={V.g5}>vão 30 m</text>
    </svg>
    <div style={{fontSize:10,color:V.g4,marginTop:2,fontStyle:'italic'}}>{estrutura}</div>
  </div>);
}

export { PassCross };
export default PassCross;
